module.exports = __webpack_public_path__ + "static/media/muestra.e422fa36.svg";